/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { InputWrapper, StyledTextarea } from './styled';
import type { TextareaProps } from './types';

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      variant = 'default',
      size = 'md',
      hasError = false,
      disabled = false,
      fullWidth = true,
      minHeight = 100,
      className,
      testId = 'textarea',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <InputWrapper $fullWidth={fullWidth} className={className} style={style}>
        <StyledTextarea
          ref={ref}
          $variant={variant}
          $size={size}
          $hasError={hasError}
          $fullWidth={fullWidth}
          $minHeight={minHeight}
          disabled={disabled}
          data-testid={testId}
          data-variant={variant}
          data-error={hasError || undefined}
          aria-invalid={hasError || undefined}
          css={css}
          {...rest}
        />
      </InputWrapper>
    );
  }
);

Textarea.displayName = 'Textarea';
